import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from '@angular/core';
import { MemberModel } from '../../../../models/user.model';
import { MemberService } from '../../../../services/member.service';
import { HelpersService } from '../../../../services/helpers.service';
import { LayoutDataService } from '../../services/lyaout-data.service';
@Component({
    selector: 'app-m-layout-user-profile',
    templateUrl: './layout-user-profile.component.html',
    styleUrl: './layout-user-profile.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppLayoutUserProfileComponent {
	public userProfile:MemberModel & {full_name?:string}|null=null
	public hasAvatar:boolean = false
	constructor(
		private memberService:MemberService,
		private helpersService:HelpersService,
		private cds:ChangeDetectorRef,
    private layoutDataService:LayoutDataService,
	){}
	ngOnInit(): void {
		this.memberService.getCurrentMember().then(data=>{
			this.userProfile = data
			this.userProfile.full_name = this.helpersService.fullName(this.userProfile)||this.helpersService.shortFullName(this.userProfile)
			this.cds.detectChanges()
		})
	}
	selectCompany (){
		this.userProfile? this.layoutDataService.selectCompany(this.userProfile) : null
	}
	logout(): void {
		this.memberService.logout();
	}
}